import React from "react";
import { Link } from "react-router-dom";
import isExternal from "is-url-external";

const Anchor = (props) => {
  return props.to === "#!" ? (
    <div className={props.className} {...props}>
      {" "}
      {props.children}
    </div>
  ) : isExternal(props.to) ? (
    <a
      className={props.className}
      href={props.to !== null ? props.to : "#!"}
      style={props.style}
      tabIndex={props.tabIndex ? props.tabIndex : ""}
      {...props}
    >
      {props.children}
    </a>
  ) : (
    <Link
      to={props.to}
      className={props.className}
      style={props.style}
      {...props}
    />
  );
};

export default Anchor;
